<div class="print-settings-container" [formGroup]="hospitalReportSettingForm">
    <!-- Sidebar Settings -->
    <div class="settings-sidebar">
        <div class="settings-tabs">
            <mat-tab-group animationDuration="0ms">
                <mat-tab label="HEADER">
                    <div class="settings-content">
                        <!-- Logo Size -->
                        <div class="setting-group">
                            <label class="f-w-700">{{ 'LABEL.LOGO_SIZE' | translate }}</label>
                            <div class="segmented-control">
                                <mat-button-toggle-group formControlName="logoSize" class="cardWithShadow">
                                    <mat-button-toggle *ngFor="let size of logoSizes" [value]="size.value">
                                        {{size.label}}
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <!-- Logo Position -->
                        <div class="setting-group">
                            <label class="f-w-700">{{ 'LABEL.LOGO_POSITION' | translate }}</label>
                            <div class="segmented-control">
                                <mat-button-toggle-group formControlName="logoPosition" class="cardWithShadow">
                                    <mat-button-toggle *ngFor="let pos of logoPositions" [value]="pos.value">
                                        {{pos.label}}
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <!-- Address Alignment -->
                        <div class="setting-group">
                            <label class="f-w-700">{{ 'LABEL.ADDRESS_ALIGNMENT' | translate }}</label>
                            <div class="segmented-control">
                                <mat-button-toggle-group formControlName="addressAlignment" class="cardWithShadow">
                                    <mat-button-toggle *ngFor="let align of addressAlignments" [value]="align.value">
                                        {{align.label}}
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <!-- Address Font Size -->
                        <div class="setting-group">
                            <div class="hospital-name-size-label d-flex justify-content-between f-w-600 f-s-12">
                                <span class="text-uppercase">{{ 'LABEL.ADDRESS_FONT_SIZE' | translate }}</span>
                                <span
                                    class="f-s-14">{{hospitalReportSettingForm.get('addressFontSize')?.value}}PX</span>
                            </div>
                            <mat-slider min="8" max="24" step="1" color="primary">
                                <input matSliderThumb formControlName="addressFontSize">
                            </mat-slider>
                        </div>

                        <!-- Hospital Name Size -->
                        <div class="setting-group">
                            <div class="hospital-name-size-label d-flex justify-content-between f-w-600 f-s-12">
                                <span class="text-uppercase">{{ 'LABEL.HOSPITAL_NAME_SIZE' | translate }}</span>
                                <span
                                    class="f-s-14">{{hospitalReportSettingForm.get('hospitalNameSize')?.value}}PX</span>
                            </div>
                            <mat-slider min="12" max="40" step="1" color="primary">
                                <input matSliderThumb formControlName="hospitalNameSize">
                            </mat-slider>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="FOOTER">
                    <div class="settings-content">
                        <!-- Show Footer Toggle -->
                        <div class="setting-group">
                            <div class="d-flex align-items-center justify-content-between">
                                <label class="f-w-700 m-0">Footer</label>
                                <mat-slide-toggle formControlName="showFooter" color="primary"></mat-slide-toggle>
                            </div>
                            <p class="f-s-12 text-muted mt-2">
                                {{ 'LABEL.FOOTER_MESSAGE' | translate }}
                            </p>
                        </div>

                        <!-- Doctor Name Position -->
                        <div class="setting-group mt-4" *ngIf="hospitalReportSettingForm.get('showFooter')?.value">
                            <label class="f-w-700">{{ 'LABEL.DOCTOR_NAME_POSITION' | translate }}</label>
                            <div class="segmented-control">
                                <mat-button-toggle-group formControlName="doctorNamePosition" class="cardWithShadow">
                                    <mat-button-toggle *ngFor="let pos of doctorNamePositions" [value]="pos.value">
                                        {{pos.label}}
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>

        <div class="reset-button d-flex gap-8 justify-content-center">
            <button mat-flat-button color="primary" (click)="onSave()">
                {{ 'BUTTON.BTN_SAVE' | translate }}
            </button>
            <button mat-stroked-button color="warn" (click)="resetToDefault()">
                {{ 'BUTTON.BTN_RESET' | translate }}
            </button>
        </div>
    </div>

    <!-- Preview Area -->
    <div class="preview-area">
        <div class="a4-container cardWithShadow">
            <!-- Simulated Header -->
            <div class="preview-header" [ngClass]="'pos-' + hospitalReportSettingForm.get('logoPosition')?.value">
                <div class="preview-logo cardWithShadow"
                    [style.width]="hospitalReportSettingForm.get('logoSize')?.value"
                    [style.height]="hospitalReportSettingForm.get('logoSize')?.value">
                    <img *ngIf="logoUrl" [src]="logoUrl"
                        style="width: 100%; height: 100%; object-fit: contain; border-radius: inherit;">
                    <div *ngIf="!logoUrl">LOGO<br><span>{{hospitalReportSettingForm.get('logoSize')?.value}}</span>
                    </div>
                </div>
                <div class="hospital-info" *ngIf="hospitalInfo as info"
                    [style.text-align]="hospitalReportSettingForm.get('addressAlignment')?.value">
                    <h2 [style.font-size.px]="hospitalReportSettingForm.get('hospitalNameSize')?.value" class="fw-700">
                        {{ info.name || 'Hospital Name' }}
                    </h2>

                    <p [style.font-size.px]="hospitalReportSettingForm.get('addressFontSize')?.value">
                        {{ info.address || 'Hospital Address' }}
                    </p>

                    <p [style.font-size.px]="hospitalReportSettingForm.get('addressFontSize')?.value">
                        Phone: {{ info.phone || info.mobile || '1234567890' }}
                    </p>
                </div>
            </div>

            <!-- Doctor Info at Top (Below Header) -->
            <div class="preview-doctor-top" *ngIf="hospitalReportSettingForm.get('showFooter')?.value && hospitalReportSettingForm.get('doctorNamePosition')?.value === 'top'">
                <div class="doctor-info">
                    <p class="doctor-name">Dr. Jane Doe</p>
                    <p class="doctor-degree">MBBS, MS (General Surgery)</p>
                </div>
            </div>

            <!-- Dummy Content -->
            <div class="preview-body">
                <div class="dummy-row header">
                    <div class="col" style="flex: 2">Patient Name</div>
                    <div class="col" style="flex: 1">Gender</div>
                    <div class="col" style="flex: 1">OPD No</div>
                    <div class="col" style="flex: 1">Date</div>
                </div>
                <div class="dummy-row">
                    <div class="col" style="flex: 2">G SARAYU</div>
                    <div class="col" style="flex: 1">Female</div>
                    <div class="col" style="flex: 1">425022026</div>
                    <div class="col" style="flex: 1">25/02/2026</div>
                </div>
                <!-- Case History -->
                <div style="margin-top: 20px; border: 1px solid #ddd; padding: 10px;">
                    <div style="font-weight: bold; margin-bottom: 5px; border-bottom: 1px solid #eee;">
                        Case History</div>
                    <div style="font-size: 10px; color: #666;">Ano rectal Pain ...</div>
                </div>
            </div>

            <!-- Simulated Footer -->
            <div class="preview-footer" *ngIf="hospitalReportSettingForm.get('showFooter')?.value && hospitalReportSettingForm.get('doctorNamePosition')?.value === 'footer'">
                <div class="doctor-info">
                    <p class="doctor-name">Dr. Jane Doe</p>
                    <p class="doctor-degree">MBBS, MS (General Surgery)</p>
                </div>
            </div>
        </div>

        <div class="preview-footer-text">
            A4 scaled preview — changes update instantly
        </div>
    </div>
</div>